import BaseTable from "./base-table";

function MarketingTable() {
    return (
        <BaseTable>
            <tbody>
                <tr>
                    <td className="border border-gray-300 p-2">_skg_*</td>
                    <td className="border border-gray-300 p-2"><a href="https://skorstensgaard.dk/persondatapolitik">skorstensgaard.dk</a></td>
                    <td className="border border-gray-300 p-2">Vi brugere denne local storage til at gøre bruger oplevelsen bedre.</td>
                    <td className="border border-gray-300 p-2">14 dage</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">_fbp</td>
                    <td className="border border-gray-300 p-2"><a href="https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc">facebook.com</a></td>
                    <td className="border border-gray-300 p-2">Facebook pixel bruger denne cookie til at styre unikke applikationer.</td>
                    <td className="border border-gray-300 p-2">7 dage</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">_uetvid</td>
                    <td className="border border-gray-300 p-2"><a href="https://help.ads.microsoft.com/apex/index/3/en/53056/">microsoft.com</a></td>
                    <td className="border border-gray-300 p-2">Microsoft Ads bruger denne cookie til at styre unikke applikationer. Dette er en Microsoft cookie.</td>
                    <td className="border border-gray-300 p-2">13 måneder</td>
                    <td className="border border-gray-300 p-2">Cookie</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">_uetsid</td>
                    <td className="border border-gray-300 p-2"><a href="https://help.ads.microsoft.com/apex/index/3/en/53056/">microsoft.com</a></td>
                    <td className="border border-gray-300 p-2">Microsoft Ads bruger denne cookie til at styre unikke applikationer. Dette er en Microsoft cookie.</td>
                    <td className="border border-gray-300 p-2">1 dag</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">MUID</td>
                    <td className="border border-gray-300 p-2"><a href="https://help.ads.microsoft.com/apex/index/3/en/53056/">microsoft.com</a></td>
                    <td className="border border-gray-300 p-2">Microsoft Ads bruger denne cookie til at identificerer unikke webbrowsere, der besøger Microsoft-websteder. Disse cookies bruges til annoncering, webstedsanalyse og andre operationelle formål.</td>
                    <td className="border border-gray-300 p-2">1 dag</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">MSPTC</td>
                    <td className="border border-gray-300 p-2"><a href="https://help.ads.microsoft.com/apex/index/3/en/53056/">microsoft.com</a></td>
                    <td className="border border-gray-300 p-2">Microsoft Ads bruger denne cookie til indsamle data om den besøgendes brug af hjemmesiden. Dette benyttes til at optimere relevansen af hjemmesidens annoncer.</td>
                    <td className="border border-gray-300 p-2">1 år</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">AnalyticsSyncHistory</td>
                    <td className="border border-gray-300 p-2"><a href="https://www.linkedin.com/legal/l/cookie-table">linkedin.com</a></td>
                    <td className="border border-gray-300 p-2">LinkedIn bruger denne cookie til at gemme oplysninger om det tidspunkt, en synkronisering fandt sted med lms_analytics-cookien</td>
                    <td className="border border-gray-300 p-2">30 dage</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">UserMatchHistory</td>
                    <td className="border border-gray-300 p-2"><a href="https://www.linkedin.com/legal/l/cookie-table">linkedin.com</a></td>
                    <td className="border border-gray-300 p-2">LinkedIn bruger denne cookie til at ID synk</td>
                    <td className="border border-gray-300 p-2">30 dage</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">li_gc</td>
                    <td className="border border-gray-300 p-2"><a href="https://www.linkedin.com/legal/l/cookie-table">linkedin.com</a></td>
                    <td className="border border-gray-300 p-2">LinkedIn bruger denne cookie til at gemme samtykke fra gæster vedrørende brugen af cookies til ikke-væsentlige formål</td>
                    <td className="border border-gray-300 p-2">6 måneder</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">li_sugr</td>
                    <td className="border border-gray-300 p-2"><a href="https://www.linkedin.com/legal/l/cookie-table">linkedin.com</a></td>
                    <td className="border border-gray-300 p-2">LinkedIn bruger denne cookie til at lave et sandsynligt match af en brugers identitet uden for de udpegede lande</td>
                    <td className="border border-gray-300 p-2">90 dage</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">lidc</td>
                    <td className="border border-gray-300 p-2"><a href="https://www.linkedin.com/legal/l/cookie-table">linkedin.com</a></td>
                    <td className="border border-gray-300 p-2">LinkedIn bruger denne cookie til at lette valg af datacenter</td>
                    <td className="border border-gray-300 p-2">24 timer</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
                <tr>
                    <td className="border border-gray-300 p-2">bcookie</td>
                    <td className="border border-gray-300 p-2"><a href="https://www.linkedin.com/legal/l/cookie-table">linkedin.com</a></td>
                    <td className="border border-gray-300 p-2">LinkedIn bruger denne cookie til entydigt at identificere enheder, der får adgang til LinkedIn for at opdage misbrug på platformen og diagnostiske formål</td>
                    <td className="border border-gray-300 p-2">1 år</td>
                    <td className="border border-gray-300 p-2">Cookie/Local Storage</td>
                </tr>
            </tbody>
        </BaseTable>
    )
}

export default MarketingTable;